import { useCallback } from "react";
import { useSelector } from "react-redux";
import { FlightsCfarTrackingEvent } from "@b2bportal/core-types";
import { useDeviceType } from "@b2bportal/core-utilities";
// eslint-disable-next-line @nx/enforce-module-boundaries
import { trackEvent } from "@hopper-b2b/api";
import { FlightsCfarOffersSelectors } from "../store";

export function useChooseCfarTracking() {
  const chooseTrackingProperties = useSelector(
    FlightsCfarOffersSelectors.getChooseCfarV2TrackingProperties
  );

  return useCallback(() => {
    trackEvent({
      eventName: FlightsCfarTrackingEvent.CHOOSE_CFAR,
      ...chooseTrackingProperties,
    });
  }, [chooseTrackingProperties]);
}

export function useDesktopOnlyChooseCfarTracking() {
  const trackCfarChoose = useChooseCfarTracking();
  const { isDesktopAndUp } = useDeviceType();

  return useCallback(() => {
    if (isDesktopAndUp) {
      trackCfarChoose();
    }
  }, [isDesktopAndUp, trackCfarChoose]);
}
